export default {
  dark: {
    // Dark mode
    type: Boolean,
    default() {
      return false
    }
  },

  fields: {
    // Array of field definitions
    type: Array,
    default() {
      return [
        {
          id: 'testField',
          label: 'Example field'
        }
      ]
    }
  },

  value: {
    // This is the data-object set by v-model (so value should not be specified as a prop, only v-model)
    type: Object,
    default() {
      return {
        testField: 'FIELD CONFIGURATION MISSING'
      }
    }
  },

  cols: {
    type: [Number, String],
    default() {
      return 'fit'
    }
  },

  colspacing: {
    type: [Number, String],
    default() {
      return 0
    }
  },

  rowspacing: {
    type: [Number, String],
    default() {
      return 4
    }
  },

  autofocus: {
    type: Boolean,
    default() {
      return false
    }
  },

  asterisk: {
    type: Boolean,
    default() {
      return true
    }
  },

  mincolwidth: Number,

  labelcaps: {
    // If true, field labels are displayed in caps
    type: Boolean,
    default() {
      return true
    }
  },

  border: {
    // If true, gives fields a shadow border
    type: Boolean,
    default() {
      return false
    }
  },

  rowlines: {
    // If true, shows faint line between rows
    type: Boolean,
    default() {
      return false
    }
  },

  filled: {
    type: Boolean,
    default() {
      return true
    }
  },

  square: {
    type: Boolean,
    default() {
      return false
    }
  },

  stackLabel: {
    type: Boolean,
    default() {
      return true
    }
  },

  outlined: Boolean,
  rounded: Boolean,
  dense: Boolean
}
